module.exports = __webpack_public_path__ + "img/Logo_iNoe_192px.fb064199.png";